import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {getStates, getCities, getCountryCities, getPolicyAcceptance, getUserProjectLines, getUfValues, getCompanyTaxesOptions} from '@/helpers/api/general'

const messagesStore = {
  namespaced: true,
  state: {
		ordinalsNumbers: [
			"Cero", "Primero", "Segundo", "Tercero", "Cuarto", "Quinto", "Sexto", "Séptimo", "Octavo", 
			"Noveno", "Décimo", "Undécimo", "Duodécimo", "Décimotercero", "Décimocuarto", 
			"Décimoquinto", "Décimosexto", "Décimoséptimo", "Décimooctavo", "Décimonoveno", "Vigésimo", 
			"Vigésimo primero", "Vigésimo segundo", "Vigésimo tercero", "Vigésimo cuarto", 
			"Vigésimo quinto", "Vigésimo sexto", "Vigésimo séptimo", "Vigésimo octavo", 
			"Vigésimo noveno", "Trigésimo"
		],
		romanNumerals: [
			"0", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", 
			"XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX", 
			"XXI", "XXII", "XXIII", "XXIV", "XXV", "XXVI", "XXVII", "XXVIII", 
			"XXIX", "XXX"
		],
		generalOptionsModal: false,
		generalConfirmationModal: null,
		importantNotificationModal: true,
		importantNotificationModalData: null,
		newCreatedElement: null,
    messagesToMessageCenter: [],
		messagesQueueToMessageCenter: [],
		// chatRoomCenter: [{id: 15, name: 'Chat de prueba'}],
		chatRoomCenter: [],
		headerHeight: 0,
		viewerHeight: window.innerHeight,
		loadingStates: false,
		states: [],
		loadingCities: false,
		cities: [],
		loadingCountryCities: false,
		countryCities: [],
		holidayDays: [],
		policiesLists: [],
		loadingPolicies: false,
		userGeo: null,
		newBudgetModal: null,
		userTypePromptModal: false,
		userTypePromptModalTab: 1,
		addressModal: null,
		dayUfValue: 40000,
		posteriorDaysUf: null,
		selectedFile: null,
		publicProfileModal: false,
		publicProfileModalEdditing: null,
		existentDocumentNotificationModal: false,
		existentDocumentNotificationModalData: null,
		openModalOrders: [],
		importantNotificationSessionShown: false,
		loadingUserProjectLines: false,
		userProjectLines: [],
		taxesOptions: [],
		loadingTaxesOptions: false,
		taxesOptionsModal: false,
		taxesOptionsModalEditting: null,
		manualPaymentOrderModal: null
  },
  mutations: {
		setHeaderHeight(state, height) {
			state.headerHeight = height
		},
		setNewCreatedElement(state, element) {
			state.newCreatedElement = element
		},
		setPublicProfileModal(state, publicProfileModal) {
			state.publicProfileModal = publicProfileModal
		},
		setPublicProfileModalEdditing(state, publicProfileModalEdditing) {
			state.publicProfileModalEdditing = publicProfileModalEdditing
		},
		setLoadingStates(state, value){
			state.loadingStates = value
		},
		setStates(state, value){
			state.states = value
		},
		setLoadingCities(state, value){
			state.loadingCities = value
		},
		setCities(state, value){
			state.cities = value
		},
		setLoadingCountryCities(state, value){
			state.loadingCountryCities = value
		},
		setCountryCities(state, value){
			state.countryCities = value
		},
		setLoadingPolicies(state, value){
			state.loadingPolicies = value
		},
		setPolicies(state, value){
			state.policiesLists = value
		},
		setHolidayDays(state, value){
			state.holidayDays = value
		},
		setUserGeo(state, value){
			state.userGeo = value
		},
		setNewBudgetModal(state, value){
			state.newBudgetModal = value
		},
		setNewBudgetModalStatus(state, value){
			state.newBudgetModal.status = value
		},
		setDayUfValue(state, value){
			state.dayUfValue = value
		},
		setPosteriorDaysUf(state, value){
			state.posteriorDaysUf = value
		},
		setUserTypePromptModal(state, value){
			// Si es false, cierra el modal
			// Si es un número, abre el modal y establece el tab
			// Si es true, abre el modal con tab 1
			console.log('setUserTypePromptModal', value)
			if(value === false){
				state.userTypePromptModal = false
				state.userTypePromptModalTab = 1
			}
			else if(typeof value === 'number'){
				state.userTypePromptModal = true
				state.userTypePromptModalTab = value
			}
			else {
				state.userTypePromptModal = true
				state.userTypePromptModalTab = 1
			}
		},
		setAddressModal(state, value){
			state.addressModal = value
		},
		setSelectedFile(state, value){
			state.selectedFile = value
		},
		setImportantNotificationModal(state, status){
			state.importantNotificationModal = status
		},
		setImportantNotificationModalData(state, data){
			state.importantNotificationModalData = data
		},
		setExistentDocumentNotificationModal(state, status){
			state.existentDocumentNotificationModal = status
		},
		setExistentDocumentNotificationModalData(state, data){
			state.existentDocumentNotificationModalData = data
		},
		addOpenModalOrders(state, timestamp){
			if (!state.openModalOrders.includes(timestamp)) {
				state.openModalOrders.push(timestamp);
			}
		},
		setImportantNotificationSessionShown(state, data){
			state.importantNotificationSessionShown = data
		},
		setLoadingUserProjectLines(state, data){
			state.loadingUserProjectLines = data
		},
		setUserProjectLines(state, data){
			state.userProjectLines = data
		},
		setTaxesOptions(state, data){
			state.taxesOptions = data
		},
		setLoadingTaxesOptions(state, data){
			state.loadingTaxesOptions = data
		},
		setTaxesOptionsModal(state, data){
			state.taxesOptionsModal = data
		},
		setTaxesOptionsModalEditting(state, data){
			state.taxesOptionsModalEditting = data
		},
		setManualPaymentOrderModal(state, data){
			state.manualPaymentOrderModal = data
		},
		setGeneralConfirmationModal(state, data){
			state.generalConfirmationModal = data
		},
		setGeneralOptionsModal(state, data){
			state.generalOptionsModal = data
		},
		setMessagesToMessageCenter(state, message) {
			state.messagesToMessageCenter = [...state.messagesToMessageCenter, message]
		},
		removeMessagesToMessageCenter(state, uuid) {
			state.messagesToMessageCenter =
				state.messagesToMessageCenter.filter(m => m.uuid !== uuid)
		},
		setMessagesQueueToMessageCenter(state, message) {
			state.messagesQueueToMessageCenter = [
				...state.messagesQueueToMessageCenter,
				message
			]
		},
		shiftMessagesQueueToMessageCenter(state) {
			const queue = [...state.messagesQueueToMessageCenter]
			const next = queue.shift()
			state.messagesQueueToMessageCenter = queue
			return next
		},
		setViewerHeight(state, height) {
			state.viewerHeight = height
		},
		addChatRoomCenter(state, room) {
			if(state.chatRoomCenter.some(r => r.id == room.id)){
				eventBus.$emit('attention-chat-room', {chat_room_id: room.id})
				return
			}

			state.chatRoomCenter = [...state.chatRoomCenter, room]
		},
		removeChatRoomCenter(state, room_id) {
			state.chatRoomCenter = state.chatRoomCenter.filter(r => r.id !== room_id)
		},
		updateChatRoomInfo(state, { roomId, roomInfo }) {
			state.chatRoomCenter = state.chatRoomCenter.map(room => {
				if (room.id == roomId) {
					console.log('Room antes de actualizar:', { ...room, ...roomInfo })
					return { ...room, ...roomInfo }
				}
				console.log('Room sin actualizar:', room)
				return room
			})
		}
  },
  getters: {
    availableHeight: state => state.viewerHeight - state.headerHeight,
    getHeaderHeight: state => state.headerHeight
  },
  actions: {
		addMessage({ commit }, message) {
			message.uuid = uuidv4()
			commit('setMessagesQueueToMessageCenter', message)
		},
		removeMessage({ commit }, uuid) {
			commit('removeMessagesToMessageCenter', uuid)
		},
		fillNextMessage({ commit, state }) {
			if (
				state.messagesToMessageCenter.length < 3 &&
				state.messagesQueueToMessageCenter.length > 0
			) {
				const next = state.messagesQueueToMessageCenter[0]
				commit('shiftMessagesQueueToMessageCenter')
				commit('setMessagesToMessageCenter', next)
			}
		},
    async getStates({ commit }) {
      commit('setLoadingStates', true)
      const data = {
        country_id: 44
      }
      const states = await getStates(data)
      if (states.code === 200) {
        commit('setStates', states.states)
      }
      commit('setLoadingStates', false)
    },
    async getCities({ commit }, state_id) {
      commit('setLoadingCities', true)
      const cities = await getCities({state_id})
      if (cities.code === 200) {
        commit('setCities', cities.cities)
      }
      commit('setLoadingCities', false)
    },
    async getCountryCities({ commit }, country_id) {
      commit('setLoadingCountryCities', true)
      const cities = await getCountryCities({country_id})
      if (cities.code === 200) {
        commit('setCountryCities', cities.cities)
      }
      commit('setLoadingCountryCities', false)
    },
    async getPolicies({ commit }, params) {
      commit('setLoadingPolicies', true)
      const policies = await getPolicyAcceptance(params)
      if (policies.code === 200) {
        commit('setPolicies', policies.policies)
      }
      commit('setLoadingPolicies', false)
    },
    async getUserProjectLines({ commit }, params) {
      commit('setLoadingUserProjectLines', true)
      const pl = await getUserProjectLines(params)
      if (pl.code === 200) {
        commit('setUserProjectLines', pl.client_project_lines)
      }
      commit('setLoadingUserProjectLines', false)
    },
    async getHolidayDays({ commit }) {
			const url = `https://api.boostr.cl/holidays.json`;
			const response = await fetch(url);
			if (response.ok) {
				const data = await response.json();
				const holidayDays = data.data.map(f => moment(f.date).format('YYYY-MM-DD'))

				commit('setHolidayDays', holidayDays)
			}
    },
    async getDayUf({ commit }) {
			// const url = `https://mindicador.cl/api`;
			const cmf_url = 'https://api.cmfchile.cl/api-sbifv3/recursos_api/uf?apikey=' + process.env.VUE_APP_CMF_API_KEY + '&formato=json';
			const response = await fetch(cmf_url);
			if (response.ok) {
				const data = await response.json();
				let formattedString = data.UFs[0].Valor.replace(/\./g, "").replace(",", ".");
				let ufValue = parseFloat(formattedString);
				commit('setDayUfValue', ufValue)
			}
    },
    async getPosteriorDaysUf({ commit }, include_ids = []) {
			const uf_values = await getUfValues(include_ids)
      if (uf_values.code === 200) {
				commit('setPosteriorDaysUf', uf_values.uf_values)
      }
			// const today = new Date();
			// const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
			// const year = yesterday.getFullYear();
			// const month = String(yesterday.getMonth() + 1).padStart(2, '0');
			// const day = String(yesterday.getDate()).padStart(2, '0');

			// const cmf_url = `https://api.cmfchile.cl/api-sbifv3/recursos_api/uf/posteriores/${year}/${month}/dias/${day}?apikey=${process.env.VUE_APP_CMF_API_KEY}&formato=json`;
			// const response = await fetch(cmf_url);
			// if (response.ok) {
			// 	const data = await response.json();
			// 	let mappedUfs = data.UFs.map((uf) => {
			// 		const value = uf.Valor.replace(/\./g, "").replace(",", ".")
			// 		return {date: uf.Fecha, uf_value: parseFloat(value)}
			// 	})
			// 	commit('setPosteriorDaysUf', mappedUfs)
			// }
    },
    async getTaxesOptions({ commit }) {
			commit('setLoadingTaxesOptions', true)
			const taxes = await getCompanyTaxesOptions()
      if (taxes.code === 200) {
				commit('setTaxesOptions', taxes.taxes)
      }
			commit('setLoadingTaxesOptions', false)
    },
  }
}

export default messagesStore
